import React from "react";
import "./Auth.css";
import loginVec from "../../Assets/Images/successVec.webp";
import brandLogo from "../../Assets/Images/brandLogo.png";
import { MdVerified } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";

const Successful = () => {
  const navigate = useNavigate();
  const [, , removeCookie] = useCookies(["accessToken"]);

  const handleClick = () => {
    removeCookie("accessToken", {
      path: "/",
      secure: true,
      httpOnly: false,
      sameSite: "Strict",
    }); // Remove authentication token
    navigate("/sign-in");
  };

  return (
    <section
      className="p-6 md:p-4 pb-16 sm:pb-0 min-h-screen flex items-center justify-center"
      style={{
        background: "linear-gradient(131.7deg, #7404FE 3.53%, #42058E 133.97%)",
      }}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 items-stretch w-full max-w-8xl mx-auto gap-0 md:gap-10">
  

        {/* Right Section (Image & Text) */}
        <div
          className="hidden md:grid relative grid-cols-1 h-full min-h-[calc(100vh-40px)] bg-cover bg-top-center rounded-xl"
          style={{ backgroundImage: `url(${loginVec})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-20 rounded-xl"></div>

          <div className="absolute top-0 text-left text-white p-8 w-3/4">
            <img src={brandLogo} alt="Brand Logo" className="w-20 h-20 mb-4 drop-shadow-lg" />
          </div>
          <div className="">
            <div className="absolute bottom-4 mx-4 w-[calc(100%-2rem)] text-left rounded-lg text-white p-3 backdrop-blur-xs border border-white/30 bg-white/10">
              <p className="capitalize text-md">
                We believe communication should be simple, fast and private.
                Whether you're chatting with friends, connecting with family or
                collaborating with your team, our platform ensures seamless
                messaging and end-to-end security.
              </p>
            </div>
          </div>
        </div>
              {/* Left Section */}
              <div className="flex items-center justify-center px-4 md:px-0">
              <div className="w-full max-w-lg">
            <MdVerified className="text-[90px] flex justify-center mx-auto mb-3 text-center text-[#06B300]" />
            <h2 className="text-3xl leading-[50px] font-bold text-white text-center mb-4">
              Your password has been <br /> changed successfully
            </h2>

            <p className="text-md text-center  text-white mb-8">
            You're all set—your password update is complete!
            </p>

            <button
              className="w-full bg-white text-black hover:text-white py-3 rounded-full text-lg font-medium hover:bg-purple-500 transition"
              onClick={() => handleClick()}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Successful;
